module.exports = __webpack_public_path__ + "img/5a133b3.png";